<template>
  <div style="padding:0 20px">
    <el-card>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <!--签收限制解除-->
        <el-tab-pane :label="$t('navbar.SignatureLimitRelease')" name="first">
          <electronicContactLimit ref="electronicContactLimitRef" />
        </el-tab-pane>
        <!--登记问题件限制解除-->
        <el-tab-pane :label="$t('navbar.RegisterProblemLimitRelease')" name="second">
          <deregistration ref="deregistrationRef" />
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>
<script>
import electronicContactLimit from './component/electronicContactLimit.vue';
import deregistration from './component/deregistration.vue';
export default {
  name: 'OperationLimitRelease',
  components: {
    electronicContactLimit,
    deregistration
  },
  data() {
    return {
      activeName: 'first'
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
      if (tab.name === 'first') {
        this.$refs.electronicContactLimitRef.getSearch();
      } else {
        this.$refs.deregistrationRef.getSearch();
      }
      console.log(tab.name, 'electronicContactLimit');
    }
  }
};
</script>

<style scoped>

</style>
